import React from 'react';
import Header from "../components/Header";
import SimpleHeader from "../components/SimpleHeader";
import Footer from "../components/Footer";
import PressRelease from "../components/PressRelease";
import PageTitle from "../components/PageTitle";

const Press = () => {
    const URL = '/images/media/';
    return (
        <>
            <PageTitle title='Press' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"press"}
                    route={"press"}
                    url={"press"}
                />
                <div className='press-release max-w'>
                    <PressRelease
                        title='Patirtis užsienyje paliko ispudi'
                        date='12.06.2022'
                        image='/presse-21.jpg'
                        url='https://kurjeris.lt/aktualijos/svietimas/patirtis-uzsienyje-paliko-ispudi/?fbclid=IwAR1tFZG02cG6XGFFvaesZ0_S7Vaw8I3qjcbuONaC7NZT8IRXhHx8xCYwMfQ'
                    />
                    <PressRelease
                        title='„Erasmus+“ programa pildo svajones'
                        date='12.06.2022'
                        image='/presse-18.jpg'
                        url='http://sprc.w3.lt/erasmus-programa-pildo-svajones/'
                    />
                    <PressRelease
                        title='„IDA-VIRUMAA" - Kutsehariduskeskus'
                        date='29.11.2021'
                        image='/presse-20.jpg'
                        url='https://kutsehariduskeskus.ee/ru/news/erasmus-praktika-v-avstrii?fbclid=IwAR1TnAv_JJlSqNFGbMBh0AD9XJA2e9H5ZTOCOTETXmvT8qqx6wJoVB_aKbE'
                    />
                    <PressRelease
                        title='„BICIULIS-Litauen" - Lankési sveciai iš Austrijos'
                        date='02.06.2021'
                        image='/presse-26.jpg'
                        url='/images/media/presse-26.jpg'
                    />
                    <PressRelease
                        title='Projekt 2018-1-EE01-KA102-046858 „Kompetentside arendamine läbi uute kogemuste“'
                        date='09.04.2018'
                        image='/presse-17.jpg'
                        url='https://kutsehariduskeskus.ee/et/uudised/projekt-2018-1-ee01-ka102-046858-kompetentside-arendamine-labi-uute-kogemuste'
                    />
                    <PressRelease
                        title='BICIULIS-Litauen - Kunstfestival XXXVII der Stadt Kelme in Litauen'
                        date='27.05.2017'
                        image='/presse-15.jpg'
                        url={URL + 'presse-15.pdf'}
                    />
                    <PressRelease
                        title='Abschlusskonferenz 2016/2017 in Litauen in der Berufsschule Margarita Rimkevicaite/ Panevezys'
                        date='27.05.2017'
                        image='/presse-14.jpg'
                        url='https://www.visasverslas.lt/portal/categories/2/1/0/1/article/10594/profesine-mokykla-praktiniai-igudziai-paklausi-profesija-ir-starto-aikstele'
                    />
                    <PressRelease
                        title='St.Veiter Stadtjournal-Delegation aus Litauen Juli 2017'
                        date='27.05.2017'
                        image='/presse-16.jpg'
                        url='https://www.sv.or.at/fileadmin/user_upload/Stadtjournal_VA-Kalender/Stadtjournal_04_2017.pdf'
                    />
                    <PressRelease
                        title='Die Lehrerdelegation aus Litauen waren Gäste im TAZ'
                        date='01.12.2016'
                        image='/presse-13.jpg'
                        url={URL + 'presse-13.pdf'}
                    />
                    <PressRelease
                        title='St. Veiter'
                        date='25.08.2016'
                        image='/presse-25.jpg'
                        url={URL + 'presse-25.jpg'}
                    />
                    <PressRelease
                        title='Bezirksjournal'
                        date='September 2016'
                        image='/presse-24.jpg'
                        url={URL + 'presse-24.jpg'}
                    />
                    <PressRelease
                        title='Karriereblog wifi Kärnten'
                        date='01.12.2015'
                        image='/presse-11.jpg'
                        url='http://karriereblog.wifi-kaernten.at/delegation-aus-litauen-und-polen-informiert-sich-ueber-das-taz/'
                    />
                    <PressRelease
                        title='Karriereblog wifi Kärnten'
                        date='09.04.2015'
                        image='/presse-8.jpg'
                        url='http://karriereblog.wifi-kaernten.at/taz-test-und-ausbildungszentrum/delegation-aus-bulgarien-informiert-sich-ueber-das-taz/'
                    />
                    <PressRelease
                        title='Kärnten-TV'
                        date='09.04.2015'
                        image='/presse-9.jpg'
                        url='http://www.kaerntentv.tv/index.php/video/818/fachberufsschule-f%C3%BCr-tourismus-im-zentrum-des-interesses/#'
                    />
                    <PressRelease
                        title='KLeine Zeitung'
                        date='15.03.2015'
                        image='/presse-10.jpg'
                        url='https://www.kleinezeitung.at/k/kaernten/feldkirchen/peak_feldkirchen/4684823/EUProjekt_EUPraktikanten-kommen-in-die-Region'
                    />
                    <PressRelease
                        title='Website: Ad Hoc News'
                        date='14.03.2015'
                        image='/presse-5.jpg'
                        url='https://www.ad-hoc-news.de/sie-bringt-europa-nach-kaernten--/de/News/41836083'
                    />
                    <PressRelease
                        title='Website Kärntner Wirtschaft'
                        date='12.03.2015'
                        image='/presse-7.jpg'
                        url='https://news.wko.at/news/kaernten/start.html'
                    />
                    <PressRelease
                        title='Webblog: utenosrpmcprojektai'
                        date='03.03.2015'
                        image='/presse-12.jpg'
                        url='http://utenosrpmcprojektai.blogspot.com/'
                    />
                    <PressRelease
                        title='Beitrag: Kärnten-TV'
                        date='12.02.2015'
                        image='/presse-4.jpg'
                        url='http://www.wp.kaerntentv.tv/kanal-kaerntentv-magazin-kw-07-2015/'
                    />
                    <PressRelease
                        title='Website: Trading House'
                        date='09.02.2015'
                        image='/presse-6.jpg'
                        url='https://www.trading-house.net/news/sport-sie-bringt-europa-nach-kaernten-41836083'
                    />
                    <PressRelease
                        title='Meine Woche'
                        date='09.02.2015'
                        image='/presse-23.jpg'
                        url='https://www.meinbezirk.at/feldkirchen/c-wirtschaft/sie-bringt-europa-nach-kaernten_a1239216'
                    />
                    <PressRelease
                        title='Kelme'
                        date='11.11.2013'
                        image='/presse-30.jpg'
                        url='https://www.kelme.lt/lit/Kelmes-rajono-savivaldybeje-viesejo-austru-delegacija-is-Veitensfeldo/637'
                    />
                    <PressRelease
                        title='E-Magazine: Blick Punkt'
                        date='24.08.2012'
                        image='/presse-3.jpg'
                        url='https://issuu.com/blick_punkt/docs/blick-punkt_240812_sv_fe_internet'
                    />
                    <PressRelease
                        title='Raseiniskis'
                        date='09.12.2011'
                        image='/presse-12.jpg'
                        url='http://raseiniskis.balsas.lt/raseiniu-naujienos/raseinieciai/dvi-mokytojos-profesinius-igudzius-tobulino-uzsienyje/'
                    />
                    <PressRelease
                        title='Meine Woche'
                        date='24.11.2010'
                        image='/presse-23.jpg'
                        url='https://www.meinbezirk.at/feldkirchen/c-politik/eu-im-gurktal_a300581'
                    />
                    <PressRelease
                        title='Kleine Zeitung'
                        date='18.11.2010'
                        image='/presse-29.jpg'
                        url='https://www.kleinezeitung.at/kaernten/feldkirchen/albeck/2561377/albeck-partnerfang-europa.story'
                    />
                    <PressRelease
                        title='Blick-Punkt'
                        date='August 2012'
                        image='/presse-28.jpg'
                    />
                    <PressRelease
                        title='Presseinformation in der Zeitung "Siauliu krastas"'
                        image='/presse-27.jpg'
                        url={URL + 'presse-27.pdf'}
                    />
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Press;